import { render, staticRenderFns } from "./candidate_age_result.vue?vue&type=template&id=29baa4a4&scoped=true&"
import script from "./candidate_age_result.vue?vue&type=script&lang=js&"
export * from "./candidate_age_result.vue?vue&type=script&lang=js&"
import style0 from "./candidate_age_result.vue?vue&type=style&index=0&id=29baa4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29baa4a4",
  null
  
)

export default component.exports